/* Dansk katalog for locale-autopilot-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.review.completed': 'Kontrolleret / godkendt',
  'ap.review.reviewApproved': 'Kontrol godkendt',
  'ap.review.approvedNotBooked': 'Godkendt · venter på bogføring',
  'ap.review.booked': 'Bogført',
  'ap.review.checked': 'Kontrolleret',
  'ap.review.queueError': 'Opgavekøen kunne ikke opdateres. Oversigten kan være ufuldstændig. Prøv igen, før du behandler forslag.',
  'ap.review.retry': 'Prøv igen',
  'ap.review.overduePeriods': '{{count}} frister er overskredet',
  'ap.review.overduePeriod': '1 frist er overskredet',
  'ap.review.overdueDetails': 'Forfaldne opfølgningspunkter: {{count}}. Indberetning: {{submissions}}. Betaling: {{payments}}.',
  'ap.review.deadlinePoints': '{{overdue}} forfaldne og {{upcoming}} kommende opfølgningspunkter',
  'ap.review.missingStatements': 'Kontoudtog mangler',
  'ap.review.missingStatementsPeriod': 'Disse konti mangler kontoudtog for {{period}}.',
  'ap.monthControl.liveTitle': 'Løbende måned',
  'ap.monthControl.liveBlockedReason': 'Måneden er i gang. Du kan behandle og godkende linjer løbende, men afslutning bliver tilgængelig efter månedens udgang.',
  'ap.cancelEntry': 'Annuller postering',
  'ap.saveEntry': 'Gem postering',
  'ap.suggestion': 'SuperPlummas forslag',
  'ap.amountIncVat': 'Beløb (inkl. moms)',
  'ap.saveCorrection': 'Gem rettelse',
  'ap.correct': 'Ret',
  'ap.openInPayroll': 'Åbn i løn',
  'ap.payrollLines': 'Lønlinjer',
  'ap.hoursCount': 'Antal timer',
  'ap.hourlyRate': 'Timesats',
  'ap.monthlyGross': 'Månedsløn (brutto)',
  'ap.holidayPayAccrued': 'Feriepenge hensat (12 %)',
  'ap.employerCosts': 'Arbejdsgivers omkostninger',
  'ap.employerContribution': 'Arbejdsgiverafgift (14,1 %)',
  'ap.mandatoryPension': 'Obligatorisk tjenestepension (2 %)',
  'ap.approveAndFile': 'Godkend og indsend',
  'ap.vatReturnTitle': 'Momsangivelse',
  'ap.post': 'Post',
  'ap.checkPost': 'Kontrollér post',
  'ap.allPostsChecked': 'Alle poster er kontrolleret.',
  'ap.registerAsset': 'Registrér aktiv',
  'ap.backToAssets': 'Tilbage til aktiver',
  'ap.confirmAsset': 'Bekræft aktiv',
  'ap.registeredAutomatically': 'Registreret automatisk',
  'ap.balanceGroup': 'Saldogruppe',
  'ap.amountExVat': 'Beløb (ekskl. moms)',
  'ap.registeredFrom': 'Registreret fra',
  'ap.registeredAssets': 'Registrerede aktiver',
  'ap.approveRegistrations': 'Godkend registreringer',
  'ap.saveAllAndApprove': 'Gem alle og godkend',
  'ap.skip': 'Spring over',
  'ap.skipped': 'Sprunget over',
  'ap.amountIncVatShort': 'Beløb inkl. moms',
  'ap.openVoucherFull': 'Åbn bilaget i fuld størrelse',
  'ap.security': 'Sikkerhed',
  'ap.dragVoucherHere': 'Træk et bilag fra indbakken hertil',
  'ap.approve': 'Godkend',
  'ap.dragVoucherOntoLine': 'Træk et bilag over på den linje, du vil knytte det til.',
  'ap.approveTask': 'Godkend opgave',
  'ap.sent': 'Sendt',
  'ap.sentCount': '{{count}} sendt',
  'ap.openVatReturn': 'Åbn MVA-meldingen',
  'ap.openTask': 'Åbn opgave',
  'ap.reopenTask': 'Fortryd godkendelse',
  'ap.rerun': 'Gennemgå igen',
  'ap.rerunHelp': 'Henter køen fra Functions igen og genopbygger agentlisten. Intet bogføres eller godkendes.',
  'ap.rerunDone': 'AI Bogholder har gennemgået {{month}} igen.',
  'ap.rerunFailed': 'Kunne ikke køre gennemgangen igen.',
  'ap.staleApproval': 'Godkendt {{date}} · grundlaget er ændret siden',
  'ap.bankConnection': 'Bankforbindelse',
  'ap.agent.invoice.title': '{{count}} faktura(er) er ikke sendt',
  'ap.agent.invoice.titleDone': 'Alle fakturaer er sendt',
  'ap.agent.invoice.desc': '{{drafts}} er kladder, og {{unsent}} er færdige, men ikke sendt.',
  'ap.agent.invoice.descDone': 'Ingen kladder eller usendte fakturaer i {{year}}.',
  'ap.agent.invoice.detail': 'En kladde er hverken indtægtsført eller sendt til kunden. Afsendelse og bogføring sker fra fakturalisten.',
  'ap.agent.invoice.action': 'Åbn fakturalisten',
  'ap.agent.invoice.lineDraft': 'Kladde · ikke indtægtsført',
  'ap.agent.invoice.lineUnsent': 'Færdig, men ikke sendt',
  'ap.agent.invoice.execute': 'Send {{count}} fakturaer',
  'ap.agent.invoice.choose': 'Vælg fakturaer',
  'ap.agent.invoice.selectAll': 'Vælg alle, der kan sendes',
  'ap.agent.invoice.selectRow': 'Vælg faktura',
  'ap.agent.invoice.selectedCount': '{{count}} valgt',
  'ap.agent.invoice.sendableCount': '{{count}} kan sendes',
  'ap.agent.invoice.finishDraftFirst': 'Kladder skal færdiggøres, før de kan sendes',
  'ap.agent.invoice.sendSelectedOne': 'Send valgt faktura',
  'ap.agent.invoice.sendSelected': 'Send {{count}} valgte fakturaer',
  'ap.agent.invoice.executeDone': 'fakturaer sendt',
  'ap.agent.dunning.title': '{{count}} forfaldne faktura(er) venter på rykker',
  'ap.agent.dunning.titleDone': 'Ingen forfaldne fakturaer',
  'ap.agent.dunning.desc': '{{amount}} kr er udestående efter forfald.',
  'ap.agent.dunning.descDone': 'Alle sendte fakturaer er inden for forfald eller betalt.',
  'ap.agent.dunning.detail': 'Rykkere, rykkergebyr og morarenter sendes fra fakturalisten. AI Bogholder sender ikke noget selv.',
  'ap.agent.dunning.action': 'Åbn fakturalisten',
  'ap.agent.dunning.line': 'Forfaldt for {{days}} dag(e) siden · faktura {{num}}',
  'ap.agent.dunning.execute': 'Send {{count}} påmindelser',
  'ap.agent.dunning.executeTitle': 'Send betalingspåmindelser',
  'ap.agent.dunning.executeWarn': 'Påmindelserne går direkte til kunderne og kan ikke trækkes tilbage. Kunder, der lige har betalt, uden at betalingen er registreret, får også en.',
  'ap.agent.dunning.executeNote': 'Plumme rykker ikke for den samme faktura oftere end hver syvende dag og springer fakturaer over, der er udlignet eller mangler kundens e-mail.',
  'ap.agent.dunning.executeDone': 'påmindelser sendt',
  'ap.agent.inbox.title': '{{count}} bilag i indbakken er ikke bogført',
  'ap.agent.inbox.titleDone': 'Indbakken er tom',
  'ap.agent.inbox.desc': '{{ready}} er klar til bogføring, og {{review}} skal kontrolleres.',
  'ap.agent.inbox.descAnalyzing': '{{count}} bilag læses stadig.',
  'ap.agent.inbox.descDone': 'Ingen bilag venter på behandling.',
  'ap.agent.inbox.detail': 'Bilag læses automatisk, når de kommer ind. Bogføring og kontovalg godkendes i indbakken.',
  'ap.agent.inbox.action': 'Åbn indbakken',
  'ap.agent.inbox.execute': 'Bogfør {{count}} klare bilag',
  'ap.agent.inbox.executeDone': 'bilag bogført',
  'ap.agent.inbox.voucher': 'Bilag',
  'ap.agent.inbox.lineReady': 'Læst og klar til bogføring',
  'ap.agent.inbox.lineReview': 'Skal kontrolleres før bogføring',
  'ap.agent.reconcile.title': '{{count}} måned(er) er ikke afstemt',
  'ap.agent.reconcile.titleDone': 'Alle afsluttede måneder er afstemt',
  'ap.agent.reconcile.descEarly': 'Ingen måneder er afsluttet i {{year}} endnu.',
  'ap.agent.reconcile.desc': '{{closed}} af {{total}} afsluttede måneder er afstemt og bogført.',
  'ap.agent.reconcile.descDone': 'Driftskontoen er afstemt til og med sidste måned.',
  'ap.agent.reconcile.detail': 'En måned regnes som afstemt, når kontoudtoget for driftskontoen er bogført og arkiveret i Bank. Afstemning skal ske kronologisk.',
  'ap.agent.reconcile.action': 'Åbn bank',
  'ap.agent.reconcile.titleBlockedOrder': '{{month}} skal afstemmes først',
  'ap.agent.reconcile.descBlockedOrder': 'Afstemning sker kronologisk. Primosaldoen hentes fra forrige måned, så en afvigelse der ville blive usynlig her.',
  'ap.agent.reconcile.detailBlockedOrder': 'Gå til Bank, og gør den ældste uafstemte periode færdig. Så åbner denne måned af sig selv.',
  'ap.agent.reconcile.reasonBlockedOrder': 'Venter på {{month}}',
  'ap.agent.reconcile.line': 'Intet afstemt kontoudtog for driftskontoen',
  'ap.agent.quality.title': '{{count}} fund i kvalitetskontrollen',
  'ap.agent.quality.titleDone': 'Ingen fund i kvalitetskontrollen',
  'ap.agent.quality.desc': '{{missing}} køb mangler bilag, og {{duplicates}} kan være bogført to gange.',
  'ap.agent.quality.descDone': 'Alle køb i {{year}} har bilag, og der er ikke fundet mulige dobbeltposteringer.',
  'ap.agent.quality.detailVat': 'Køb uden bilag står for {{vat}} kr i momsfradrag, som kan blive underkendt ved en kontrol.',
  'ap.agent.quality.detail': 'Mulige dobbeltposteringer er køb med samme leverandør, beløb og dato. De skal vurderes manuelt, før noget annulleres.',
  'ap.agent.quality.action': 'Åbn transaktioner',
  'ap.agent.quality.purchase': 'Køb',
  'ap.agent.quality.lineDuplicate': '{{count}} posteringer med samme leverandør, beløb og dato',
  'ap.agent.quality.lineMissing': 'Mangler bilag · åbn købet for at uploade eller knytte dokumentation',
  'ap.agent.deadline.titleOverdue': '{{count}} frist(er) er overskredet',
  'ap.agent.deadline.title': '{{count}} frist(er) nærmer sig',
  'ap.agent.deadline.titleDone': 'Ingen frister de næste 30 dage',
  'ap.agent.deadline.desc': 'Nærmeste frist er {{name}} {{date}}.',
  'ap.agent.deadline.descOverdue': '{{count}} forfalden indberetning er ikke afklaret.',
  'ap.agent.deadline.descDone': 'Alle indberetninger med frist inden for 30 dage er indsendt.',
  'ap.agent.deadline.lineNotFiled': 'Forfalden · ikke indsendt',
  'ap.agent.deadline.lineNotPaid': 'Forfalden · ikke markeret som betalt',
  'ap.agent.deadline.detail': 'Fristerne følger virksomhedens momsperiode og selskabsform. Indsendelse sker fra Indberetninger.',
  'ap.agent.deadline.action': 'Åbn indberetninger',
  'ap.agent.deadline.lineOverdue': 'Overskredet med {{days}} dag(e)',
  'ap.agent.deadline.line': '{{days}} dag(e) tilbage',
  'ap.agent.annualDeadline.subjectMany': '{{count}} indberetninger',
  'ap.agent.annualDeadline.titleDone': 'Fristerne i {{month}} er afklaret',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} er ikke indsendt — fristen er overskredet',
  'ap.agent.annualDeadline.title': '{{subject}} har frist i {{month}}',
  'ap.agent.annualDeadline.desc': '{{name}} for {{year}} har frist {{date}}.',
  'ap.agent.annualDeadline.descDone': 'Alle indberetninger med frist i {{month}} er markeret som indsendt.',
  'ap.agent.annualDeadline.detail': 'Fristen ligger i året efter indkomståret, så dette gælder regnskabet for {{year}} — ikke {{calendarYear}}. Rækken blokerer ikke godkendelsen af måneden.',
  'ap.agent.annualDeadline.action': 'Åbn',
  'ap.agent.annualDeadline.lineFiled': 'Markeret som indsendt',
  'ap.agent.annualDeadline.execute': 'Markér som indsendt uden for Plumme',
  'ap.agent.annualDeadline.executeTitle': 'Markér aksjonærregisteroppgaven som indsendt',
  'ap.agent.annualDeadline.executeWarn': 'Plumme sender ingenting. Dette noterer kun, at indberetningen er indsendt et andet sted, så fristen holder op med at give besked.',
  'ap.agent.annualDeadline.executeNote': 'Aksjonærregisteroppgaven (RF-1086) indsendes fra et slutbrugersystem eller Altinn. Andelsboligselskaber er undtaget, og selskaber, hvor Euronext VPS indsender på selskabets vegne, skal ikke indsende selv.',
  'ap.agent.annualDeadline.executeDone': 'markeret',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} skal behandles i årsarbejdsgangen.',
  'ap.agent.mileage.title': '{{count}} ture i kørebogen mangler dokumentation',
  'ap.agent.mileage.titleOk': '{{count}} ture i kørebogen er dokumenteret',
  'ap.agent.mileage.titleEmpty': 'Ingen kørsel registreret i {{year}}',
  'ap.agent.mileage.desc': 'Kørebogen giver {{amount}} kr i fradrag i {{year}}.',
  'ap.agent.mileage.descEmpty': 'Erhvervskørsel giver fradrag, men kun når turene er ført med dato, strækning, formål og kilometer.',
  'ap.agent.mileage.detail': 'En kørebog skal vise dato, fra og til, formål og antal kilometer for hver tur. Ture uden dette kan blive underkendt.',
  'ap.agent.mileage.action': 'Åbn kørebog',
  'ap.agent.mileage.trip': 'Tur uden strækning',
  'ap.agent.mileage.lineNoPurpose': 'Mangler formål',
  'ap.agent.mileage.lineNoKm': 'Mangler kilometer',
  'ap.agent.mileage.lineNoRoute': 'Mangler strækning',
  'ap.agent.match.title': '{{count}} banklinjer mangler bilag',
  'ap.agent.match.titleDone': 'Alle banklinjer har bilag',
  'ap.agent.match.desc': '{{count}} bilag ligger i indbakken og kan passe.',
  'ap.agent.match.descDone': 'Ingen banklinjer mangler dokumentation.',
  'ap.agent.match.detail': 'Et bilag tilknyttes kun automatisk, når det passer til én banklinje, og banklinjen passer til ét bilag. Er der tvivl, skal du selv vælge.',
  'ap.agent.match.action': 'Åbn bank',
  'ap.agent.match.line': 'Mangler bilag',
  'ap.agent.match.execute': 'Tilknyt bilag automatisk',
  'ap.agent.match.executeTitle': 'Tilknyt bilag til banklinjer',
  'ap.agent.match.executeWarn': 'Bilagene tilknyttes som dokumentation på banklinjerne. Intet bogføres — det sker først, når du afstemmer kontoudtoget.',
  'ap.agent.match.executeNote': 'Kun entydige match tilknyttes: bilaget skal passe til én banklinje, og banklinjen til ét bilag. Alt andet står tilbage til manuelt valg.',
  'ap.agent.match.executeDone': 'bilag tilknyttet',
  'ap.agent.contacts.supplier': 'leverandører',
  'ap.agent.contacts.customer': 'kunder',
  'ap.agent.contacts.title': 'Op til {{count}} {{noun}} mangler i registret',
  'ap.agent.contacts.titleDone': 'Alle {{noun}} er registreret',
  'ap.agent.contacts.desc': 'Navne, der går igen i regnskabet uden at være i registret.',
  'ap.agent.contacts.descDone': 'Ingen gentagne navne uden for registret.',
  'ap.agent.contacts.detail': 'Kun navn og organisationsnummer oprettes. E-mail, telefon og adresse skal du selv udfylde — Plumme gætter ikke på kontaktoplysninger, der kan ende på en faktura.',
  'ap.agent.contacts.openSuppliers': 'Åbn leverandører',
  'ap.agent.contacts.openCustomers': 'Åbn kunder',
  'ap.agent.contacts.line': '{{count}} posteringer',
  'ap.agent.contacts.execute': 'Opret manglende {{noun}}',
  'ap.agent.contacts.executeTitle': 'Opret {{noun}} i registret',
  'ap.agent.contacts.executeWarn': 'Navnene oprettes i registret. Eksisterende posteringer tilknyttes ikke automatisk — det gør du, når du åbner posten.',
  'ap.agent.contacts.executeNote': 'Plumme opretter kun navne, der går igen mindst to gange, og springer betalingstekst som »Visa« og »Vipps« over.',
  'ap.agent.contacts.executeDone': 'oprettet',
  'ap.contact.supplierNumber': 'Leverandørnr.',
  'ap.contact.supplierNumberPh': 'F.eks. 20001',
  'ap.contact.supplierName': 'Leverandørnavn',
  'ap.contact.customerName': 'Kundenavn',
  'ap.contact.namePh': 'Navn',
  'ap.contact.customerNamePh': 'F.eks. Eksempel AS',
  'ap.contact.org': 'Org.nummer',
  'ap.contact.orgOptional': 'Org.nummer (valgfrit)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'faktura@leverandor.no',
  'ap.contact.customerEmailPh': 'post@eksempel.no',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Adresse',
  'ap.contact.addressPh': 'Gadeadresse',
  'ap.contact.supplierAddressPh': 'Gadeadresse, postnr. og by',
  'ap.agent.tax.titleBlocked': 'Skattegrundlaget er ikke tilgængeligt',
  'ap.agent.tax.descBlocked': 'Regnskabstallene for {{year}} er ikke indlæst.',
  'ap.agent.tax.detail': 'Indsendelse af skattemelding kræver Altinn-integration, som ikke er tilsluttet endnu.',
  'ap.agent.tax.blocked': 'Mangler regnskabstal',
  'ap.agent.tax.titleDone': 'Skattemeldingen for {{year}} er indsendt',
  'ap.agent.tax.title': 'Skattegrundlaget for {{year}} er beregnet',
  'ap.agent.tax.descEnk': 'Resultat før skat: {{result}} kr. Enkeltmandsvirksomheder beskattes hos ejeren.',
  'ap.agent.tax.desc': 'Resultat før skat {{result}} kr giver {{tax}} kr i beregnet skat.',
  'ap.agent.tax.action': 'Åbn skattemelding',
  'ap.agent.tax.lineResult': 'Resultat før skat',
  'ap.agent.tax.lineTax': 'Beregnet skat',
  'ap.agent.tax.lineLoss': 'Underskud til fremførsel',
  'ap.agent.annual.titleBlocked': 'Årsregnskabet er ikke tilgængeligt',
  'ap.agent.annual.descBlocked': 'Regnskabstallene for {{year}} er ikke indlæst.',
  'ap.agent.annual.blocked': 'Mangler regnskabstal',
  'ap.agent.annual.titleNotRequired': 'Virksomheden har ikke pligt til at aflægge årsregnskab',
  'ap.agent.annual.descNotRequired': 'Enkeltmandsvirksomheder indsender i stedet næringsspesifikasjon sammen med skattemeldingen.',
  'ap.agent.annual.action': 'Åbn årsregnskab',
  'ap.agent.annual.stepDocument': 'Årsregnskabsdokumentet',
  'ap.agent.annual.stepBoard': 'Bestyrelsesprotokol',
  'ap.agent.annual.stepAssembly': 'Generalforsamlingsprotokol',
  'ap.agent.annual.stepSigned': 'Signering',
  'ap.agent.annual.titleDone': 'Årsregnskabet for {{year}} er indsendt',
  'ap.agent.annual.title': '{{count}} trin tilbage i årsregnskabet for {{year}}',
  'ap.agent.annual.titleReady': 'Årsregnskabet for {{year}} er klar til indsendelse',
  'ap.agent.annual.descClosed': 'Regnskabsåret er afsluttet.',
  'ap.agent.annual.descOpen': 'Regnskabsåret er ikke afsluttet endnu.',
  'ap.agent.annual.detail': 'Indsendelse til Regnskapsregisteret kræver Altinn-integration, som ikke er tilsluttet endnu.',
  'ap.agent.annual.line': 'Ikke fuldført',
  'ap.execute.title': 'Bogfør fra AI-bogholder',
  'ap.execute.running': 'Bogfører …',
  'ap.execute.warnTitleGeneric': 'Dette kan ikke fortrydes',
  'ap.execute.warnTitle': 'Dette bogfører i dit regnskab',
  'ap.execute.warnBody': 'Bilagene bogføres som køb med konto, moms og betalingsmåde fra bilagsanalysen. Du er ansvarlig for, at posteringerne er korrekte, og skal annullere manuelt, hvis noget går galt.',
  'ap.execute.checked': 'Plumme kontrollerer hvert bilag igen, før det bogføres. Bilag, der ikke lever op til kravene, bliver liggende i indbakken med en begrundelse.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': '{{booked}} bilag bogført',
  'ap.execute.partialCount': '{{done}} {{skipped}} blev ikke udført og skal følges op.',
  'ap.execute.failed': 'Bogføringen blev ikke gennemført.',
  'ap.lastRun': 'Sidst gennemgået {{when}}',
  'ap.lastRunLabel': 'Sidst gennemgået',
  'ap.bankDataHelp': 'SuperPlumma bruger de kontoudtog, du har importeret under Bank. Direkte bankforbindelse findes endnu ikke — upload kontoudtog som XLSX eller CSV, så banklinjerne kommer ind.',
  'ap.bankData': 'Bankdata',
  'ap.bankStatementImported': 'Kontoudtog importeret',
  'ap.noBankData': 'Intet kontoudtog importeret',
  'ap.noData': 'Ingen data',
  'ap.importBankStatement': 'Importér kontoudtog',
  'ap.loadingTitle': 'Henter dit regnskab …',
  'ap.loadingText': 'SuperPlumma venter på data fra dit regnskab. Opgavelisten vises, så snart tallene er indlæst.',
  'ap.disconnectBank': 'Afbryd bank',
  'ap.connected': 'Forbundet',
  'ap.noBankConnected': 'Ingen bank forbundet',
  'ap.connectBankHelp': 'Forbind din bank, så SuperPlumma kan bogføre banktransaktioner.',
  'ap.bankIdNote': 'Forbindelsen oprettes sikkert med BankID.',
  'ap.missingBasis': 'Mangler grundlag',
  'ap.rowDescMissing': 'Mangler oplysninger, før AI-bogholderen kan arbejde videre.',
  'ap.rowBlockedReasonDefault': 'Kræver opsætning eller data',
  'ap.rowOpen': 'Åbn',
  'ap.working': 'Arbejder …',
  'ap.execute.queued': 'Sat i kø. Køres, selvom du lukker siden – du får besked, når den er færdig.',
  'ap.execute.queueFailed': 'Handlingen kunne ikke sættes i kø.',
  'ap.job.done': '{{booked}} udført.',
  'ap.job.donePartial': '{{booked}} udført · {{skipped}} blev ikke udført og skal følges op.',
  'ap.job.failed': 'Handlingen blev ikke gennemført.',
  'ap.waiting': 'Afventer',
  'ap.waitingDetail': 'Kan ikke behandles endnu',
  'ap.waitingGroup.title': '{{count}} agenter afventer',
  'ap.waitingGroup.titleOne': '{{agent}} afventer',
  'ap.waitingGroup.detail': 'Bliver aktuelle, når perioden er klar',
  'ap.oneLineNeedsControl': ' linje skal kontrolleres',
  'ap.manyLinesNeedControl': ' linjer skal kontrolleres',
  'ap.readyHere': '{{count}} er klar',
  'ap.openWorklist': 'Åbn arbejdslisten',
  'ap.controlWorklist': 'Kontrollér arbejdsliste',
  'ap.controlTask': 'Kontrollér',
  'ap.openPage': 'Åbn side',
  'ap.waitsForPrevious': 'Venter',
  'ap.nextStep': 'Næste trin',
  'ap.comeBackLater': 'Kom tilbage senere',
  'ap.solveBlocker': 'Løs blokering',
  'ap.getBankData': 'Hent bankdata',
  'ap.approved': 'Godkendt',
  'ap.whichAgents': 'Hvilke agenter vil du aktivere?',
  'ap.allAgents': 'Alle agenter',
  'ap.settings.enabledCount': '{{on}} af {{total}} til',
  'ap.settings.intro': 'SuperPlumma og agenterne arbejder løbende med dit regnskab. Vælg, hvilke agenter du ønsker skal hjælpe dig. Du kan når som helst ændre indstillingerne senere. Arbejde, der ikke er aktiveret, skal du selv udføre manuelt.',
  'ap.settings.allHelp': 'Aktivér eller deaktivér alle på én gang.',
  'ap.permission.inbox.label': 'Indbakkeagenten',
  'ap.permission.inbox.desc': 'Læser kvitteringer og fakturaer, der kommer ind via e-mail eller upload, og klargør dem til bogføring.',
  'ap.permission.matching.label': 'Bilagsagenten',
  'ap.permission.matching.desc': 'Matcher bilag fra indbakken med banklinjer, der mangler dokumentation, når matchet er entydigt.',
  'ap.permission.reconciliation.label': 'Afstemningsagenten',
  'ap.permission.reconciliation.desc': 'Sørger for, at hver afsluttet måned faktisk er afstemt og bogført mod driftskontoen.',
  'ap.permission.control.label': 'Kontrolagenten',
  'ap.permission.control.desc': 'Leder efter køb uden bilag og mulige dobbeltposteringer i regnskabet.',
  'ap.permission.asset.label': 'Aktivagenten',
  'ap.permission.asset.desc': 'Foreslår driftsmiddel for større køb. Du vælger udgiftsførsel eller saldogruppe, før det samme bilag bogføres én gang.',
  'ap.permission.vendor.label': 'Leverandøragenten',
  'ap.permission.vendor.desc': 'Opretter nye leverandører, når SuperPlumma opdager gentagne posteringer fra samme leverandør.',
  'ap.permission.customer.label': 'Kundeagenten',
  'ap.permission.customer.desc': 'Opretter nye kunder, når SuperPlumma opdager salg til ukendte kunder.',
  'ap.permission.invoice.label': 'Fakturaagenten',
  'ap.permission.invoice.desc': 'Følger op på fakturakladder og færdige fakturaer, der ikke er sendt til kunden.',
  'ap.permission.dunning.label': 'Rykkeragenten',
  'ap.permission.dunning.desc': 'Holder styr på forfaldne fakturaer, og hvad der bør rykkes for først.',
  'ap.permission.deadline.label': 'Fristagenten',
  'ap.permission.deadline.desc': 'Advarer om indsendelsesfrister, der nærmer sig eller er overskredet.',
  'ap.permission.mileage.label': 'Kørebogsagenten',
  'ap.permission.mileage.desc': 'Tjekker, at erhvervskørsel er registreret med strækning, formål og kilometer, så fradraget holder.',
  'ap.permission.vat.label': 'Momsagenten',
  'ap.permission.vat.desc': 'Afstemmer moms og klargør MVA-meldingen til indsendelse.',
  'ap.permission.tax.label': 'Skatteagenten',
  'ap.permission.tax.desc': 'Forudfylder skattemeldingen ud fra dit regnskab.',
  'ap.permission.payroll.label': 'Lønagenten',
  'ap.permission.payroll.desc': 'Holder styr på lønkørsler, der venter på godkendelse. Beregning og godkendelse foregår i lønvisningen.',
  'ap.permission.annual.label': 'Årsregnskabsagenten',
  'ap.permission.annual.desc': 'Klargør årsregnskab og noter ved årsafslutningen.',
  'ap.beta': 'Beta',
  'ap.heroTitle': 'SuperPlumma gør arbejdet – du har kontrollen.',
  'ap.heroSub': 'Se, hvad der mangler, kontrollér forslag, og godkend næste trin.',
  'ap.aboutHelp': 'SuperPlumma samler opgaver og klargør forslag ud fra tilgængelige data. Bogføring og afsendelse kræver din godkendelse. Kontakten styrer den automatiske gennemgang, ikke indsendelse eller betaling.',
  'ap.enabledDescription': 'SuperPlumma gennemgår regnskabet hver morgen og samler det, der venter. Vælg, hvilke områder agenterne skal se på. Intet bogføres eller sendes, uden at du godkender det.',
  'ap.disabledDescription': 'Autopiloten er slået fra. Slå den til, så SuperPlumma kan se regnskabet igennem i baggrunden.',
  'ap.monthOpenHelp': 'SuperPlumma klargør forslag løbende gennem måneden. Nogle trin afventer, til perioden er klar, men alt opdateres automatisk, når nyt grundlag kommer ind.',
  'ap.monthControl.label': 'Månedskontrol',
  'ap.monthControl.permissionDesc': 'Behandler banklinjer, bilag, modparter og mulige aktiver og afstemmer måneden i ét samlet arbejdsforløb.',
  'ap.monthControl.blockedDesc': 'Bankgrundlaget mangler. Bilag uden banklinje kan stadig behandles.',
  'ap.monthControl.actionableDesc': '{{count}} punkter mangler i {{period}}. Banklinjer, bilag, modparter, aktiver og afstemning behandles samlet.',
  'ap.monthControl.doneDesc': 'Månedskontrollen for {{period}} er gennemgået.',
  'ap.monthControl.title': 'Månedskontrol for **{{period}}**',
  'ap.monthControl.detail': 'Behandl banklinjer kronologisk, tilknyt bilag, opret manglende modparter, og vurdér mulige aktiver i samme arbejdsområde. Godkendelsen kan fortrydes; endelig bogføring sker stadig med Afstem og bogfør.',
  'ap.monthControl.waitingDetail': 'Perioden er i gang — nye linjer kan stadig komme',
  'ap.monthControl.blockedReason': 'Mangler kontoudtog eller bankdækning',
  'ap.monthControl.action': 'Åbn månedskontrol',
  'ap.monthControl.findingsEmpty': 'Ingen mulige afvigelser.',
  'ap.monthControl.finding.deviation': 'Mulig afvigelse',
  'ap.monthControl.finding.missingVoucher': 'Mangler bilag',
  'ap.monthControl.finding.needsReview': 'Skal kontrolleres før afstemning.',
  'ap.monthControl.count.inboxOne': '{{count}} bilag i indbakken',
  'ap.monthControl.count.inboxMany': '{{count}} bilag i indbakken',
  'ap.monthControl.count.bankMissingVoucherOne': '{{count}} banklinje uden bilag',
  'ap.monthControl.count.bankMissingVoucherMany': '{{count}} banklinjer uden bilag',
  'ap.monthControl.count.bankLineOne': '{{count}} banklinje',
  'ap.monthControl.count.bankLineMany': '{{count}} banklinjer',
  'ap.monthControl.count.reconciliationOne': '{{count}} afstemning',
  'ap.monthControl.count.reconciliationMany': '{{count}} afstemninger',
  'ap.monthControl.count.qualityOne': '{{count}} fund i kvalitetskontrollen',
  'ap.monthControl.count.qualityMany': '{{count}} fund i kvalitetskontrollen',
  'ap.monthControl.count.assetOne': '{{count}} aktiv',
  'ap.monthControl.count.assetMany': '{{count}} aktiver',
  'ap.monthControl.count.supplierOne': '{{count}} leverandør',
  'ap.monthControl.count.supplierMany': '{{count}} leverandører',
  'ap.monthControl.count.customerOne': '{{count}} kunde',
  'ap.monthControl.count.customerMany': '{{count}} kunder',
  'ap.monthControl.count.itemOne': '{{count}} punkt',
  'ap.monthControl.count.itemMany': '{{count}} punkter',
  'ap.monthControl.noDate': 'Uden dato',
  'ap.monthControl.action.paySupplierInvoice': 'Betal leverandørfaktura',
  'ap.monthControl.action.registerSupplierInvoice': 'Registrér leverandørfaktura',
  'ap.monthControl.action.invoicePayment': 'Fakturabetaling',
  'ap.monthControl.action.registerSale': 'Registrér salg',
  'ap.monthControl.action.registerPurchase': 'Registrér køb',
  'ap.monthControl.block.needsControl': 'Bilaget skal kontrolleres før bogføring.',
  'ap.monthControl.block.missingBookingType': 'Mangler bogføringstype.',
  'ap.monthControl.block.missingInvoiceNumber': 'Mangler fakturanummer.',
  'ap.monthControl.block.lowConfidence': 'Lav sikkerhed i analysen.',
  'ap.monthControl.block.manualReview': 'Bilaget kræver manuel kontrol.',
  'ap.monthControl.edit.purchase': 'Ret køb',
  'ap.monthControl.edit.sale': 'Ret salg',
  'ap.monthControl.edit.bankFee': 'Ret gebyr',
  'ap.monthControl.edit.invoicePayment': 'Ret fakturabetaling',
});
